import React, { useState } from 'react';
import './About.css';
import personalImage from '../../images/personal-image.png';

const certifications = [
  'AWS Certified Solutions Architect – Associate (2024)',
  'Microsoft Certified: Azure Data Scientist Associate (2022)',
  'Microsoft Certified: Azure Fundamentals (2022)',
  'Introduction to Big Data with Spark and Hadoop — Coursera (2021)',
];

const experiences = [
  {
    company: 'IskayPet',
    role: 'Solutions Architect / Data Architect',
    period: 'Feb 2023 – actualidad',
    location: 'Málaga, Híbrido',
    bullets: [
      'Diseño y mantenimiento de arquitectura de datos escalable y segura con AWS (EMR, Step Functions, Lambda, Glue, PySpark).',
      'Colaboración con equipos multidisciplinares para asegurar que las soluciones de datos cumplan requisitos técnicos y de negocio.',
      'Automatización de infraestructura con Terraform y mantenimiento de sistemas en producción.',
    ],
  },
  {
    company: 'MDW',
    role: 'Big Data Engineer',
    period: 'Nov 2021 – Feb 2023',
    location: 'Remoto',
    bullets: [
      'Implementación y mantenimiento de procesos ETL con Azure Data Factory hacia Synapse y Azure Data Lake Gen2.',
      'Desarrollo de tests de consistencia y calidad de datos con PySpark en Databricks.',
      'Infraestructura como código con Terraform y CI/CD en Azure DevOps.',
    ],
  },
  {
    company: 'Capgemini',
    role: 'Big Data Engineer',
    period: 'Abr 2021 – Nov 2021',
    location: 'Murcia',
    bullets: [
      'Procesos ETL de empresa internacional con tecnología Talend.',
      'Queries complejas y análisis de datalake en Azure Synapse.',
    ],
  },
  {
    company: 'NEORIS',
    role: 'Junior Consultant',
    period: 'Feb 2020 – May 2020',
    location: 'Murcia',
    bullets: [
      'Business Intelligence con Power Platform.',
    ],
  },
  {
    company: 'Univ. Murcia',
    role: 'Internship – Dpto. Ingeniería Informática',
    period: 'Sep 2018 – Jun 2019',
    location: 'Murcia',
    bullets: [
      'Investigación y desarrollo con tecnología FPGA.',
    ],
  },
];

const About = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section id="sobre-mi">
      <h2 className="section-heading">sobre mí</h2>
      <div className="about-grid">
        <div className="about-bio">
          <p>
            Ingeniero Informático por la Universidad de Murcia. Solutions Architect &amp; Data Architect
            en IskayPet. Especialista en arquitecturas de datos con AWS, Azure y PySpark.
            Creador de contenido en{' '}
            <a href="https://www.instagram.com/r2d2.coder/" target="_blank" rel="noreferrer">
              @r2d2.coder
            </a>{' '}
            enseñando programación y tecnología.
          </p>
          <ul className="cert-list">
            {certifications.map((cert, i) => (
              <li key={i}>
                <span className="chevron">▹</span>
                {cert}
              </li>
            ))}
          </ul>
        </div>
        <div className="about-photo">
          <img src={personalImage} alt="Arturo Lorenzo" />
        </div>
      </div>

      <h2 className="section-heading experience-heading">experiencia</h2>
      <div className="experience-layout">
        <div className="exp-tabs" role="tablist" aria-label="Experiencia profesional">
          {experiences.map((exp, i) => (
            <button
              key={i}
              role="tab"
              aria-selected={activeTab === i}
              className={`exp-tab${activeTab === i ? ' active' : ''}`}
              onClick={() => setActiveTab(i)}
            >
              {exp.company}
            </button>
          ))}
        </div>
        <div className="exp-content" role="tabpanel">
          <h3 className="exp-role">
            {experiences[activeTab].role}{' '}
            <span className="exp-company">@ {experiences[activeTab].company}</span>
          </h3>
          <p className="exp-period">
            {experiences[activeTab].period} · {experiences[activeTab].location}
          </p>
          <ul className="exp-bullets">
            {experiences[activeTab].bullets.map((bullet, i) => (
              <li key={i}>
                <span className="chevron">▹</span>
                {bullet}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
